import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowExpandVer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowExpandVer"><Path fillRule="evenodd" clipRule="evenodd" d="M12.0001 1.68945L17.3108 7.00011L16.2501 8.06077L12.7501 4.56076V19.4395L16.2501 15.9395L17.3108 17.0001L12.0001 22.3108L6.68945 17.0001L7.75012 15.9395L11.2501 19.4394V4.56079L7.75012 8.06077L6.68945 7.00012L12.0001 1.68945Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowExpandVer;
